import { FiAlertCircle, FiAlertTriangle, FiXCircle } from 'react-icons/fi';
import { useTheme } from 'styled-components';

import { Button } from '../Buttons/Button';
import { Container, Content, Footer } from './styles';

export type TypeAlert = 'success' | 'error';

export type AlertProps = {
  type: TypeAlert;
  message: string;
};

type Props = {
  isOpen: boolean;
  close: () => void;
} & AlertProps;

export function Alert({ type, message, isOpen, close }: Props) {
  const theme = useTheme();
  const handleCloseAndReload = () => {
    close();
  };
  return (
    <Container overlayClassName="react-error-overlay" isOpen={isOpen}>
      <button type="button" onClick={handleCloseAndReload}>
        <FiXCircle
          size={22}
          fill={theme.colors.tertiary_500}
          color={theme.colors.background_white}
          style={{ flexShrink: 0 }}
        />
      </button>
      <Content type={type}>
        {type === 'success' ? (
          <FiAlertCircle
            fill={theme.colors.secondary}
            color={theme.colors.background_white}
            size={60}
            style={{ flexShrink: 0 }}
          />
        ) : (
          <FiAlertTriangle
            size={60}
            fill={theme.colors.error}
            color={theme.colors.background_white}
            style={{ flexShrink: 0 }}
          />
        )}

        <div>
          <p>{type === 'success' ? 'Sucesso' : 'Erro'}</p>
          <p>{message}</p>
        </div>
      </Content>
      <Footer>
        <Button
          text="Fechar"
          dimensions={{ width: '10.75rem', height: '1.875rem' }}
          background={type === 'success' ? 'secondary' : 'primary'}
          font={{ size: 13, weight: 400 }}
          onClick={handleCloseAndReload}
        />
      </Footer>
    </Container>
  );
}
